import { has } from 'lodash';

export const headerData = {
  // tableName: 'Conversation',
  hasSearch: true,
  hasPaging: true,
  hasTryMe: true,
  // hasExport: true,
  fields: [
    {
      fieldName: 'count',
      headerName: 'Count',
    },
    {
      fieldName: 'chatTitle',
      headerName: 'Questions',
    },
    {
      fieldName: 'createdOn',
      headerName: 'Date And Time',
      isDatetime: true,
      hasSort: true,
      isDesc: true,
    },
  ],
};
